<label class="toggle">
  <input type="checkbox" [checked]="isToggle" (change)="sendValue()" [id]="idToggle">
  <span class="slider round"></span>
</label>
